import { render } from "./AllegationCreateForm.vue?vue&type=template&id=68a70c8e&ts=true"
import script from "./AllegationCreateForm.vue?vue&type=script&lang=ts"
export * from "./AllegationCreateForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__